export const SEND_EMAIL = 'SEND_EMAIL';
export const RESET_PASSWORD = 'RESET_PASSWORD';